import { useTranslation } from 'react-i18next'

import { RadioButtonOptionCard } from '@reveni-io/reveni-ui'

import SectionHeader from '../SectionHeader/SectionHeader'
import * as SharedStyles from '../styles'
import ReturnInstructionSelector from './ReturnInstructionSelector/ReturnInstructionSelector'
import { returnMethodToInstructionType, visibilityCards, visibilityInputName } from './constants'
import * as Styles from './styles'

const VisibilitySection = ({ config, onChange, disabled, deliveryMethodType, storeId }) => {
  const { t } = useTranslation()

  const handleChangeVisibility = value => onChange({ visibility: value })

  return (
    <Styles.Container>
      <SectionHeader
        title={t('Visibilidad y detalles')}
        description={t('Los clientes verán este método al solicitar su devolución en el portal')}
      />
      <SharedStyles.CardsGrid columns={2}>
        {visibilityCards.map(card => {
          return (
            <RadioButtonOptionCard
              key={card.value}
              icon={<card.Icon size={24} weight="thin" />}
              title={t(card.title)}
              description={t(card.description)}
              name={visibilityInputName}
              value={card.value}
              selected={config?.visibility === card.value}
              disabled={disabled}
              onChange={handleChangeVisibility}
            />
          )
        })}
      </SharedStyles.CardsGrid>
      <ReturnInstructionSelector
        key={returnMethodToInstructionType[deliveryMethodType]}
        storeId={storeId}
        instructionType={returnMethodToInstructionType[deliveryMethodType]}
        selectedInstructionSetId={config?.return_instruction_set_id}
        onChange={onChange}
      />
    </Styles.Container>
  )
}

export default VisibilitySection
